import { inject, Injectable } from '@angular/core';
import { SessionStorage, SessionStorageService } from '@mwe/utils';
import { IGoodieAlert, IGoodiesModel } from '@mwe/models';

const goodiesAlertsKey = 'goodies_alerts';

@Injectable({ providedIn: 'root' })
export class GoodieStateService {
  goodies: IGoodiesModel[] = [];
  requestGoodiesPromise: Promise<IGoodiesModel[]>;

  @SessionStorage(goodiesAlertsKey)
  private _alerts: Array<IGoodieAlert> | undefined;

  private storage = inject(SessionStorageService);

  clearGoodies(): void {
    this.goodies = [];
    this.requestGoodiesPromise = null;
  }

  clearData(): void {
    this.storage.clear(goodiesAlertsKey);
    this.clearGoodies();
  }

  public getAlerts(purge = true): Array<IGoodieAlert> {
    const alerts = this._alerts || undefined;
    if (purge) {
      this.storage.clear(goodiesAlertsKey);
    }
    return alerts;
  }

  public addAlert(alert: IGoodieAlert): void {
    if (!this._alerts) {
      this._alerts = [];
    }
    this._alerts.push(alert);
  }
}
